// extracted by mini-css-extract-plugin
export default {"header-wrapper":"SectionHeader_header-wrapper__KGYaq","header-text":"SectionHeader_header-text__dVa2-"};